
import React from 'react';

const HowItWorksSection = () => {
  return (
    <section className="container mx-auto px-4 py-16">
      <h2 className="text-3xl font-bold text-center mb-12">How VirtuStaff.ai Works</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="flex flex-col items-center text-center">
          <div className="h-16 w-16 rounded-full bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center mb-4">
            <span className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">1</span>
          </div>
          <h3 className="text-xl font-semibold mb-2">Onboard Your Business</h3>
          <p className="text-muted-foreground">Tell us about your business, brand, and goals for your AI staff team.</p>
        </div>
        <div className="flex flex-col items-center text-center">
          <div className="h-16 w-16 rounded-full bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center mb-4">
            <span className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">2</span>
          </div>
          <h3 className="text-xl font-semibold mb-2">Build Your AI Team</h3>
          <p className="text-muted-foreground">Choose from various AI staff roles to create your custom team.</p>
        </div>
        <div className="flex flex-col items-center text-center">
          <div className="h-16 w-16 rounded-full bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center mb-4">
            <span className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">3</span>
          </div>
          <h3 className="text-xl font-semibold mb-2">Automate & Optimize</h3>
          <p className="text-muted-foreground">Let your AI staff handle routine tasks while you focus on growing your business.</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
